
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/transparency",
      function () {
        return require("private-next-pages/transparency.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/transparency"])
      });
    }
  